import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { TrackerService } from '@shared/services/tracker.service';
import { ProcessEventService } from '@shared/services/process-event.service';

@Component({
  selector: 'app-none-accounts-found',
  templateUrl: './none-accounts-found.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'max-w-full d-flex flex-col justify-center items-center text-center',
  },
})
export class NoneAccountsFoundComponent implements OnInit {
  isPopinOpen = false;

  constructor(
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'NONE_ACCOUNTS' });
  }

  openPopin() {
    this.isPopinOpen = true;
  }

  closePopin() {
    this.isPopinOpen = false;
  }

  abandon() {
    this.tracker.trackClick({
      click: frenchi18n.none_accounts_found_abandon,
      taggingPage: 'NONE_ACCOUNTS',
    });

    this.processEventService.push(ProcessEventFactory.SpawnAbandonEvent());
  }

  connectToOtherBank() {
    this.tracker.trackClick({
      click: frenchi18n.connect_to_other_bank_btn,
      taggingPage: 'NONE_ACCOUNTS',
    });

    this.processEventService.push(ProcessEventFactory.SpawnGoBackToBankChoiceEvent());
  }
}
